"use client";

import {
  ALL_PRODUCTS_KEY,
  CATEGORY_KEY_PREFIX,
} from "@faire/retailer-visitor-shared/components/LoggedOutBrand/consts";
import { Path } from "@faire/web/common/Path";
import { parseQueryParams } from "@faire/web/common/query-params/parseQueryParams";
import { History } from "history";
import { useLocation } from "react-router-dom";

const DEFAULT_CATEGORY_FILTER_KEY = `${CATEGORY_KEY_PREFIX}${ALL_PRODUCTS_KEY}`;

export const useLoggedOutProductFilters = (
  locationPush: (location: History.LocationDescriptor) => void
) => {
  const location = useLocation();
  const filters = parseQueryParams(location.search).get("filters");

  // Logged-out page currently only supports filtering by a single C2.
  const selectedCategoryFilterKey = filters
    ?.split(",")
    .find((filter) => filter.startsWith(CATEGORY_KEY_PREFIX));

  const activeTab = selectedCategoryFilterKey ?? DEFAULT_CATEGORY_FILTER_KEY;

  const setCategoryFilterKey = (categoryFilterKey: string) => {
    const path = getPathWithCategoryFilterKey(location, categoryFilterKey);

    locationPush({
      pathname: path.pathname,
      search: path.searchParams.toString(),
    });
  };

  return {
    selectedCategoryFilterKey,
    activeTab,
    setCategoryFilterKey,
  };
};

const getPathWithCategoryFilterKey = (
  location: { pathname: string; search: string },
  categoryFilterKey: string
): Path => {
  const path = new Path(location);
  if (categoryFilterKey === DEFAULT_CATEGORY_FILTER_KEY) {
    path.delete("filters");
  } else {
    path.replace({ filters: categoryFilterKey });
  }
  return path;
};
